import type { Cell } from '@tanstack/react-table';
import { useMemo } from 'react';

import type { ViewKeywordDto } from '@adflow/shared/data-google-ads';
import type { DataTableItemType } from '@adflow/shared/util-column-templates';

import { searchKeyword } from './search-keywords';

interface UseExtendedSearchMatchProps<T> {
	type: DataTableItemType;
	search: string;
	data: T;
	cells: Cell<T, unknown>[];
}

export function useExtendedSearchMatch<T extends object>({
	type,
	search,
	data,
	cells,
}: UseExtendedSearchMatchProps<T>) {
	return useMemo(() => {
		if (!data || !search) {
			return;
		}

		/**
		 * Don't show matches for columns that are already being shown in the table.
		 */
		const visibleColumns: string[] = cells.map((cell) => cell.column.id) ?? [];

		if (type === 'keyword') {
			const keyword = data as ViewKeywordDto;
			return searchKeyword({ keyword, search, visibleColumns });
		}
	}, [data, search, cells, type]);
}
